import { ICustomer, IPouchRows } from 'shared-types/index';

import CustomerNormaliseService from 'external-services/customer-normalise-service';
import { cloneDeep } from 'lodash-es';
import PouchLoadService from 'external-services/pouch-load-service';

const NS = 'CustomerOfflineService'; // jshint ignore:line

class CustomerOfflineService {
  private pouchService: any;
  private trackEvent: any;

  private customersCache: ICustomer[] = null;

  public setup(pouchService: any): void {
    this.pouchService = pouchService;
  }

  public init(trackEvent: () => void): void {
    this.trackEvent = trackEvent;
  }

  /**
   * Used only in offline mode
   * Load from offline, cache them and return
   */
  public getAllOffline(): Promise<ICustomer[]> {
    return new Promise((resolve, reject) => {
      // customers cache is valid
      if (this.customersCache) {
        resolve(this.customersCache);
        return;
      }

      // load customers from pouch
      const t0 = performance.now();
      Promise.resolve(
        PouchLoadService.getDbLocal()
          .allDocs({
            include_docs: true,
            attachments: false,
            startkey: 'customer_',
            endkey: 'customer_\uffff',
          })
          .then((result: unknown) => {
            const _result = result as unknown as IPouchRows<ICustomer>;
            this.trackEvent(
              'customersGetAll',
              [['duration', performance.now() - t0]],
              [['totalCustomers', _result.rows.length]]
            );
            this.setCustomerCache(
              _result.rows.map((item: { doc: ICustomer }) =>
                CustomerNormaliseService.normalizeModelToView(item.doc)
              )
            );
            resolve(this.customersCache);
          })
          .catch((err: any) => {
            console.error('error loading offline customers', err);
            reject(err);
          })
      );
    });
  }

  public removeOffline(customer: ICustomer): Promise<void> {
    const customerDTO = cloneDeep(customer);
    return Promise.resolve(
      PouchLoadService.getDbLocal().remove(customerDTO as PouchDB.Core.RemoveDocument)
    ).then(() => {
      this.deleteCustomerFromCache(customerDTO._id);
    });
  }

  //*** Customer cache action */

  public deleteCustomerFromCache(targetId: string): void {
    if (this.customersCache) {
      const idx = this.customersCache.findIndex((c: { _id: string }) => c._id === targetId);
      idx > -1 && this.customersCache.splice(idx, 1);
    }
  }

  public deleteCache(): void {
    this.customersCache = null;
  }

  // public getCache(): ICustomer[] {
  //   return this.customersCache;
  // }

  private setCustomerCache(customersCache: ICustomer[]): void {
    this.customersCache = customersCache ? [...customersCache] : null;
  }

  public appendToCustomerCache(customer: ICustomer): void {
    this.customersCache.push({ ...customer });
  }

  public updateCacheByIndex(i: number, customer: ICustomer): void {
    if (i > -1) this.customersCache[i] = { ...customer };
  }

  public getCustomerCache(): ICustomer[] {
    return this.customersCache ? [...this.customersCache] : null;
  }
}

const instance = new CustomerOfflineService();
export default instance as CustomerOfflineService;
